import { useState } from "react";
import { quickTaskStorage } from "@/utils/quickTaskStorage";
import type { PanelState } from "./types";

export function useQuickTaskPanel() {
  const storage = quickTaskStorage();
  const [panelState, setPanelState] = useState<PanelState>(() => storage.getStoredPanelState());
  const [hasEverOpened, setHasEverOpened] = useState(() => storage.getStoredPanelState() !== "CLOSED");

  const openPanel = () => {
    setHasEverOpened(true);
    setPanelState("OPEN");
    storage.savePanelState("OPEN");
  };

  const minimisePanel = () => {
    setPanelState("MINIFIED");
    storage.savePanelState("MINIFIED");
  };

  const closePanel = () => setPanelState("CLOSED");

  return { panelState, hasEverOpened, openPanel, minimisePanel, closePanel };
}
